export default {
    account_banned_message: 'គណនីរបស់អ្នកត្រូវបានបិទដោយសារបំពាន {tos} របស់យើង។',
    tos: 'លក្ខខណ្ឌនៃសេវាកម្ម',
    username: 'ឈ្មោះអ្នកប្រើ',
    password_new: 'ពាក្យសម្ងាត់​ថ្មី',
    password: 'ពាក្យសម្ងាត់',
    password_confirmation: 'បញ្ជាក់លេខកូដ',
    password_placeholder: 'ប្រវែងពាក្យសម្ងាត់ត្រូវតែមានចាប់ពី 8 ដល់ 32 តួអក្សរ',
    login_title: 'រីករាយដែលបានជួបអ្នកម្តងទៀត',
    create_new_account: 'បង្កើតគណនី!',
    dont_have_account: 'ថ្មីសម្រាប់1Byte?',
    forgot_password: 'ភ្លេចពាក្យសម្ងាត់?',
    remaining_warning_message:
        'ឈ្មោះអ្នកប្រើប្រាស់ ឬ ពាក្យសម្ងាត់មិនត្រឹមត្រូវ។  អ្នកមានការព្យាយាម {remaining} ដង មុនពេលគណនីរបស់អ្នកត្រូវបានរារាំងក្នុងរយៈពេល {blockedTime} នាទី។',
    temporarily_blocked: 'ទប់ស្កាត់ជាបណ្តោះអាសន្ន',
    account_locked:
        'គណនីរបស់អ្នកមានការប៉ុនប៉ងចូលមិនបានសម្រេចច្រើនដងពេក។  សូមព្យាយាមម្តងទៀតបន្ទាប់ពី {blockedTime} នាទី។',
    account_banned: 'គណនីត្រូវបានហាមឃាត់',
    two_fa_status: {
        enabled: 'បានបើក',
        enabling: 'ការបើកដំណើរការ',
        disabled: 'ការបិទ',
        disabling: 'បិទ',
    },
    authentication_code: 'លេខកូដផ្ទៀងផ្ទាត់',
    two_factor_authentication: 'ការផ្ទៀងផ្ទាត់ពីរកត្តា',
    two_factor_authentication_hint:
        'បើកកម្មវិធីការផ្ទៀងផ្ទាត់ពីរកត្តា (TOTP) នៅលើឧបករណ៍ចល័តរបស់អ្នក ដើម្បីមើលលេខកូដផ្ទៀងផ្ទាត់របស់អ្នក។',
    scan_barcode: 'ស្កេនបាកូដនេះជាមួយកម្មវិធីរបស់អ្នក។',
    scan_barcode_hint:
        'ស្កេនរូបភាពខាងក្រោមដោយប្រើកម្មវិធីផ្ទៀងផ្ទាត់ពីរកត្តានៅលើទូរសព្ទរបស់អ្នក។',
    enter_digit: 'បញ្ចូលលេខកូដប្រាំមួយខ្ទង់ពីកម្មវិធី',
    enter_digit_hint:
        'បន្ទាប់ពីស្កេនរូបភាពបាកូដ កម្មវិធីនឹងបង្ហាញលេខកូដប្រាំមួយខ្ទង់ដែលអ្នកអាចបញ្ចូលខាងក្រោម',
    authentication_code_desc:
        'បើកកម្មវិធី ការផ្ទៀងផ្ទាត់ពីរកត្តា (TOTP) នៅលើឧបករណ៍ចល័តរបស់អ្នក ដើម្បីមើលលេខកូដផ្ទៀងផ្ទាត់របស់អ្នក។',
    two_factor_authentication_verified:
        'ការផ្ទៀងផ្ទាត់កត្តាពីរត្រូវបានផ្ទៀងផ្ទាត់',
    two_factor_authentication_disabled: 'ការផ្ទៀងផ្ទាត់កត្តាពីរត្រូវបានបិទ',
    enable_two_factor_confirm_title: 'តេីអ្នកចង់ដាក់ដំណេីរការកម្មវីធី 2FA?',
    enable_two_factor_confirm_content:
        'អ្នកអាចដាក់ដំណេីរការកម្មវិធី Two-Factor ដេីម្បីបង្កេីនសុវត្ថិភាពគណនីរបស់អ្នក',
    google_login: {
        email_existed:
            'អាសយដ្ឋានអ៊ីមែលនេះត្រូវបានភ្ជាប់ជាមួយគណនី 1Byte រួចហើយ។ ប្រើអាសយដ្ឋានអ៊ីមែលផ្សេង ឬចូលគណនីដែលមានស្រាប់',
    },
};
